import { CampaignClass, TTD_CAMPAIGN_CLASSES } from '@feathr/blackbox';

/**
 * Returns the campaign classes allowed for Meta channel.
 * Only Pixl Plus (Omni) campaigns can have Meta creatives duplicated to them.
 */
export function getMetaCampaignClasses(): CampaignClass[] {
  return [CampaignClass.Omni];
}

/**
 * Returns the campaign classes allowed for Display channel.
 * Uses TTD_CAMPAIGN_CLASSES which includes all TTD-compatible campaign types.
 */
export function getDisplayCampaignClasses(): CampaignClass[] {
  return TTD_CAMPAIGN_CLASSES;
}
